import React, { useState } from "react"
import useSearchParamStore from "../../../stores/SearchParamStore"
import TagModal from "../../../components/TagModal"
import DefaultButton from "../../../components/DefaultButton"
import { Plus } from "lucide-react"
import { SearchHeader } from "../../../components/SearchHeader"
import useStyles from "../../styles"
import { Button } from "@material-ui/core"
const ShedulesLayout = () => {
  const { searchParam, setSearchParam, setOpenModal } = useSearchParamStore()
  const classes = useStyles()

  const handleOpenTagModal = () => {
    setOpenModal(true)
  }

  return (
    <div className={classes.buttonContainer}>
      <Button
        variant="contained"
        startIcon={<Plus />}
        color="primary"
        className={classes.buttonNova}
        disableElevation
        onClick={handleOpenTagModal}
      >
        Nova
      </Button>

      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} placeholder={"Pesquisar..."} />
    </div>
  )
}

export default ShedulesLayout
